module.exports = __webpack_public_path__ + "img/individual_email-07.41eafcc6.svg";